// src/permissions.js
export const permissions = {
  ADMIN: ["/admin", "/tickethistory", "/betting-shop", "/user-management", "/reports", "/printticket", "/printreceipt", "/shift-history", "/shift-review", "/profitshare-report"],
  AGENT: ["/admin", "/tickethistory", "/reports", "/printticket", "/printreceipt", "/shift-history", "/profitshare-report"],
  AUDITOR: ["/tickethistory", "/reports", "/shift-history",  "/shift-review", "/profitshare-report"],
  CASHIER: ["/admin", "/createticket", "/validate", "/tickethistory", "/shift-management", "/printticket"],
};
